import { mode } from "@chakra-ui/theme-tools";
export const progressStyles = {
  components: {
    Progress: {
      baseStyle: {
        field: {
          borderRadius: "full",
          bg: "brand.500",
          transition: "all 0.3s ease-in-out",
        },
        track: {
          w: "100%",
          h: "8px",
          borderRadius: "full",
          bg: "gray.100",
          _dark: {
            bg: "navy.700",
          },
          _focus: {
            boxShadow: "none",
          },
        },
      },

      variants: {
        table: (props) => ({
          field: {
            bg: "brand.500",
            borderRadius: "16px",
            fontSize: "sm",
          },
          track: {
            borderRadius: "20px",
            bg: mode("blue.50", "whiteAlpha.50")(props),
            h: "8px",
            w: "54px",
          },
          thumb: {
            w: "250px",
          },
        }),
      },
    },
  },
};
